import * as React from 'react';
import { StyledChip, TextIndicatorWrapper } from './TextIndicator.styles';
/**
 * Chip with overridable colors
 */
export const TextIndicator = (props) => {
    const { textColor, iconColor, ...chipProps } = props;
    return (React.createElement(TextIndicatorWrapper, { textcolor: textColor, iconColor: iconColor, "data-testid": "TextIndicator" },
        React.createElement(StyledChip, { ...chipProps, textColor: textColor, iconColor: iconColor })));
};
TextIndicator.defaultProps = {};
export default TextIndicator;
